import type { QuestionDefinition } from "@reno-estimator/core";
import { booleanQuestion, builtInsQuestion, flooringQuestion, lightingQuestion, paintingQuestion, windowsDoorsQuestion } from "./interior-room-shared.js";

/**
 * Mudroom (Phase 13A) - see rules/mudroom.ts for the matching calculator.
 * No trim question; windows/doors is included since an exterior door
 * replacement is common mudroom scope.
 */
export const mudroomQuestions: QuestionDefinition[] = [
  flooringQuestion("mudroom", 200, "mudroom"),
  paintingQuestion("mudroom", 210),
  lightingQuestion("mudroom", 230),
  builtInsQuestion("mudroom", 240, "What about a bench, lockers, or cubbies?", "Custom bench/lockers/cubbies"),
  windowsDoorsQuestion("mudroom", 250, "Replacing or adding an exterior door/window?"),
  booleanQuestion("mudroom_heated_floor", "mudroom", "Adding in-floor heating?", 260)
];
